const ShippingLanesSetResolution = {
	LOW: 0.5,
	MEDIUM: 0.1,
	HIGH: 0.01
};
export default ShippingLanesSetResolution;
